class GifterApp extends HTMLElement {
  constructor() {
    super();
    this.handleContinue = this.handleContinue.bind(this);
    this.submitBtn = this.querySelector("button[data-checkout-btn]");
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.quantityInput = this.querySelector("quantity-input");
    this.recipient_Phone = this.querySelector("input[name='recipient_Phone']");
    this.cardType = null;
    this.eCard = {
      recipientName: null,
      gifterMessage: null,
      cardImage: null,
    };
  }

  connectedCallback() {
    this.querySelectorAll("button[data-next],button[data-prev]").forEach(
      (button) => {
        button.addEventListener("click", this.handleContinue);
      }
    );
    this.querySelectorAll(
      ".custom_variant_wrapper_container .custom_variant_wrapper"
    ).forEach((button) => {
      button.addEventListener("click", this.handleVariantChange);
    });

    this.quantityChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityChange,
      (data) => {
        this.updatePrice();
      }
    );
    // Design card Type
    this.querySelectorAll("button[data-card-design]").forEach((button) => {
      button.addEventListener("click", (event) => {
        const target = event.target;
        const nextBtn = target
          .closest(".wiq-data-step[data-step='2']")
          .querySelector("[data-next]");
        const parent = target.closest("details");
        this.cardType = target.dataset.cardId;
        this.eCard.recipientName = parent.querySelector(
          "input[name='recipientName']"
        ).value;
        this.eCard.gifterMessage = parent.querySelector(
          "input[name='giftMessage']"
        ).value;
        this.eCard.cardImage = parent.dataset.imgUrl;

        var isValid = true;
        parent.querySelectorAll(".validatable").forEach((field) => {
          if (field.type === "text") {
            if (field.value.trim() === "") {
              isValid = false;
              field.classList.add("invalid");
            } else {
              field.classList.remove("invalid");
            }
          }
        });

        target
          .closest(".wiq-data-step[data-step='2']")
          .querySelectorAll("[data-card-design-msg]")
          .forEach((el) => {
            el.setAttribute("hidden", "");
          });

        if (isValid) {
          nextBtn.removeAttribute("disabled");
          target.parentElement.querySelector("p").removeAttribute("hidden");
        } else {
          nextBtn.setAttribute("disabled", "disabled");
          target.parentElement.querySelector("p").setAttribute("hidden", "");
        }

        // console.log(this.eCard);
      });
    });

    // Front Back Card
    this.querySelectorAll("[data-design-sample]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const target = event.target;
        const value = target.getAttribute("data-design-sample");
        const parent = target.closest(".card-design-card-front-back");
        if (value == "front") {
          parent.classList.remove("back-active");
          parent.classList.add("front-active");
        } else {
          parent.classList.remove("front-active");
          parent.classList.add("back-active");
        }
      });
    });

    this.querySelector("[data-reset]").addEventListener("click", (event) => {
      event.preventDefault();
      const popup = document.querySelector("#PopupModal-removeItem");
      popup.show();
    });

    this.submitBtn.addEventListener("click", this.addToCart.bind(this));

    this.itiPhone = window.intlTelInput(this.recipient_Phone, {
      initialCountry: "us",
      strictMode: true,
      nationalMode: true,
      utilsScript:
        "https://cdn.jsdelivr.net/npm/intl-tel-input@23.3.2/build/js/utils.js",
    });

    this.findVariant();
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("#giftProduct").textContent);
    return this.variantData;
  }

  findVariant() {
    const variantId = this.querySelector(".custom_variant_wrapper.active")
      .dataset.variantId;
    this.currentVariant = this.getVariantData().find(
      (variant) => variant.id == variantId
    );
  }

  handleVariantChange(event) {
    const variantBtn = event.target;
    this.querySelectorAll(
      ".custom_variant_wrapper_container .custom_variant_wrapper"
    ).forEach((el) => el.classList.remove("active"));
    variantBtn.classList.add("active");
    this.findVariant();
    this.updatePrice();
  }
  updatePrice() {
    const qty = this.quantityInput.input.value;
    const shippingPrice = parseInt(this.dataset.shippingFee) * 100;
    const totalPrice = this.currentVariant.price * qty + shippingPrice;
    const itemPrice = Shopify.formatMoney(
      this.currentVariant.price,
      Shopify.money_format
    );
    const lineItemPrice = Shopify.formatMoney(
      this.currentVariant.price * qty,
      Shopify.money_format
    );
    const priceEL = this.querySelector(
      ".product__price-wrapper .price-item--regular"
    );

    if (priceEL) {
      priceEL.textContent = lineItemPrice;
    }

    // Item price
    this.querySelectorAll(".cart-items-top-product-price").forEach((el) => {
      el.textContent = itemPrice;
    });

    // Line Total item price
    this.querySelectorAll(
      ".product__price-wrapper .price-item--regular, [data-line-total]"
    ).forEach((el) => {
      el.textContent = lineItemPrice;
    });

    // Quantity
    this.querySelectorAll("[data-line-qty]").forEach((el) => {
      el.textContent = qty;
    });

    // Shipping Price
    this.querySelectorAll("[data-shipping-price]").forEach((el) => {
      el.textContent = Shopify.formatMoney(shippingPrice, Shopify.money_format);
    });

    // Total Price
    this.querySelectorAll("[data-total-price]").forEach((el) => {
      el.textContent = Shopify.formatMoney(totalPrice, Shopify.money_format);
    });
  }

  handleContinue(event) {
    const btn = event.target;
    var isValid = true;

    const fields = this.querySelectorAll(
      `.app-forms-wrapper [data-step="${this.dataset.step}"] .validatable`
    );

    if (btn.hasAttribute("data-next")) {
      fields.forEach((field) => {
        if (field.type === "email") {
          if (this.validateEmail(field.value)) {
            field.classList.remove("invalid");
          } else {
            isValid = false;
            field.classList.add("invalid");
          }
        } else if (field.type === "date") {
          // validate date is in the range
          const minDate = new Date(field.min);
          const maxDate = new Date(field.max);
          const date = new Date(field.value);
          if (date >= minDate && date <= maxDate) {
            field.classList.remove("invalid");
          } else {
            isValid = false;
            field.classList.add("invalid");
          }
        } else if (field.type === "text" && btn.dataset.step != 3) {
          if (field.value.trim() === "") {
            isValid = false;
            field.classList.add("invalid");
          } else {
            field.classList.remove("invalid");
          }
        } else if (field.type === "tel") {
          if (this.itiPhone.getNumber() != "") {
            if (this.itiPhone.isValidNumber()) {
              field.classList.remove("invalid");
            } else {
              isValid = false;
              field.classList.add("invalid");
            }
          } else {
            field.classList.remove("invalid");
          }
        }
      });

      if (!isValid) {
        return;
      }
    }

    this.dataset.step = btn.dataset.step;

    if (this.dataset.step == 1) {
      document
        .querySelectorAll("main .shopify-section:not(.section--product)")
        .forEach((el) => {
          el.setAttribute("hidden", "");
        });
    }

    if (this.dataset.step == 2) {
      const recipientName = this.querySelector(
        "input[name='recipient_Name']"
      ).value;
      this.querySelectorAll('[name="recipientName"]').forEach((el) => {
        el.value = recipientName;
      });
    }

    if (this.dataset.step == 3) {
      this.updatePrice();
      this.updateContent();
    }

    // scroll to top
    window.scrollTo(0, 0);
  }

  // Validate the email
  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  updateContent() {
    this.data = {
      gifterName: this.querySelector("input[name='gifterName']").value,
      gifterEmail: this.querySelector("input[name='gifterEmail']").value,
      recipientName: this.querySelector("input[name='recipient_Name']").value,
      recipientEmail: this.querySelector("input[name='recipient_Email']").value,
      recipientPhone: this.itiPhone.getNumber(),
      emailDate: this.querySelector("input[name='email_Date']").value,
      cardType: this.cardType,
      recipientName2: this.eCard.recipientName,
      gifterMessage: this.eCard.gifterMessage,
      cardImage: this.eCard.cardImage,
      variant: this.currentVariant,
      quantity: this.quantityInput.input.value,
    };

    // Update Item Name
    this.querySelectorAll("[data-item-name]").forEach((el) => {
      el.textContent = this.currentVariant.name;
    });

    this.querySelector("[data-recipientName]").textContent =
      this.data.recipientName;
    this.querySelector("[data-recipientEmail]").textContent =
      this.data.recipientEmail;
    // format date in this format: 01/28/2024
    // this.querySelector("[data-emailDate]").textContent = this.formatDate(
    //   this.data.emailDate
    // );
  }

  formatDate(date) {
    const options = { month: "2-digit", day: "2-digit", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString(undefined, options);
    return formattedDate;
  }

  addToCart(event) {
    event.preventDefault();
    this.submitBtn.setAttribute("disabled", "disabled");
    this.submitBtn.classList.add("loading");

    const body = JSON.stringify({
      id: this.currentVariant.id,
      quantity: this.data.quantity,
      properties: {
        _recipientName: this.data.recipientName,
        _recipientEmail: this.data.recipientEmail,
        _recipientPhone: this.data.recipientPhone,
        _emailDate: this.data.emailDate,
        _giftMessage: this.data.gifterMessage,
        _cardType: this.data.cardType,
        _cardImage: this.data.cardImage,
        _recipientName2: this.data.recipientName2,
        _gifterEmail: this.data.gifterEmail,
        _gifterName: this.data.gifterName,
      },
    });

    // Clear the cart
    fetch("/cart/clear.js")
      .then((response) => {
        if (response.ok) {
          return fetch(window.routes.cart_add_url, {
            ...fetchConfig(),
            ...{ body },
          });
        } else {
          throw new Error("Failed to clear cart");
        }
      })
      .then((response) => {
        if (response.ok) {
          window.location.href = "/checkout";
        } else {
          throw new Error("Failed to add item to cart");
        }
      })
      .catch((error) => {
        console.error(error);
        this.submitBtn.removeAttribute("disabled");
        this.submitBtn.classList.remove("loading");
      });
  }
}
customElements.define("gifter-app", GifterApp);

class ModalDialogPopup extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    this.addEventListener("click", (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show() {
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
  }
}
customElements.define("modal-dialog-popup", ModalDialogPopup);
